import * as React from 'react';
import { PwaHsrPropertyDestinationRefinement } from 'src/common/__generated__/api';
import { DestinationRefinementVariants } from './internals/destination-refinement-variants';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';
import { AnalyticsStore } from 'bernie-core';

const MIN_DESTINATIONS: number = 2;

export interface DestinationRefinementProps {
  title: string;
  destinations: PwaHsrPropertyDestinationRefinement.Destinations[];
  analytics?: AnalyticsStore;
}

const showDestRefinement = destinations => destinations && destinations.length >= MIN_DESTINATIONS;

export const DestinationRefinement: React.FunctionComponent<DestinationRefinementProps> = ({ destinations, title, analytics }) => {
  if (!showDestRefinement(destinations)) {
    return null;
  }
  const isCarousel = destinations.length > MIN_DESTINATIONS;

  return (
    <section className="all-b-margin-three" data-stid="destination-refinement">
      <Viewport>
        <ViewSmall>
          <DestinationRefinementVariants isCarousel={true} {...{ destinations, title, analytics }} />
        </ViewSmall>
        <ViewMedium>
          <DestinationRefinementVariants {...{ isCarousel, destinations, title, analytics }} />
        </ViewMedium>
      </Viewport>
    </section>
  );
};
